import React, { useState, useEffect } from 'react';

import TrendingOffers from './trending-offers';
import NewOnNarrativ from './new-on-narrativ';

import './home-page.scss';

const HomePage = ({}) => {
  return (
    <div className="home-page">
      <TrendingOffers />
      <NewOnNarrativ />
    </div>
  );
};

export default HomePage;
